export default __webpack_public_path__ + "static/media/nothing-to-see-here.b2464295.gif";